<button
  [attr.type]="buttonType()"
  mat-mini-fab
  (click)="clickButton()"
  [disabled]="isDisabled()"
  [color]="buttonStyle()"
  [title]="ariaLabel()"
  [ariaLabel]="ariaLabel()"
  [class]="buttonStyle()"
>
  <mat-icon [class.spinner]="animateSpinner()">{{ iconName() }}</mat-icon>
</button>
